import { BASE_URL } from './Config.js';

export class AdresseService {
  createAdresse = async (adresseData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/address/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(adresseData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la création');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error creating address:', error); throw error; }
  };

  getAllAdresses = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/address/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch addresses');
      return await response.json();
    } catch (error) { console.error('Error fetching addresses:', error); throw error; }
  };

  getAdresseById = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/address/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to fetch address');
      return await response.json();
    } catch (error) { console.error('Error fetching address:', error); throw error; }
  };

  updateAdresse = async (id, adresseData) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/address/update/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(adresseData)
      });

      if (!response.ok) {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Erreur lors de la mise à jour');
        }
        throw new Error(await response.text() || 'Erreur serveur');
      }
      return await response.json();
    } catch (error) { console.error('Error updating address:', error); throw error; }
  };

  deleteAdresse = async (id) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token) throw new Error("Aucun token d'accès trouvé.");

      const response = await fetch(`${BASE_URL}/address/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Failed to delete address');
      return true;
    } catch (error) { console.error('Error deleting address:', error); throw error; }
  };

    // Récupérer l'adresse principale d'un client par son ID
  fetchAddressByClientId = async (clientId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token || !clientId) return null;

      // Adaptez l'URL selon votre contrôleur d'adresse (ex: /api/v1/address/client/{clientId})
      const response = await fetch(`${BASE_URL}/address/client/${clientId}`, {
        method: 'GET',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        }
      });

      if (!response.ok) return null;
      return await response.json(); // Retourne l'objet AddressDTO
    } catch (error) {
      console.error("Erreur fetch adresse:", error);
      return null;
    }
  };

  // Récupérer TOUTES les adresses d'un client
fetchAllAddressesByClientId = async (clientId) => {
    try {
      const token = localStorage.getItem('accessToken');
      if (!token || !clientId) return [];

      const response = await fetch(`${BASE_URL}/address/client/${clientId}/all`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) return [];
      const data = await response.json();
      return Array.isArray(data) ? data : (data ? [data] : []);
    } catch (error) {
      console.error("Erreur fetch adresses:", error);
      return [];
    }
  };

  // Modifier une adresse
  updateAddress = async (id, dto) => {
    const token = localStorage.getItem('accessToken');
    const response = await fetch(`${BASE_URL}/address/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(dto)
    });
    if (!response.ok) throw new Error("Erreur lors de la modification de l'adresse");
    return await response.json();
  };

  
}